import { Dispatch, GetState } from "common/types";

import { getClient } from "services";
import errorHandler from "services/memoryService/errorHandler";

import {
  fetchAllLocationsActionFactory,
  locationsNeedFetching,
  receiveLocations
} from "../state";

export const fetchLocations = fetchAllLocationsActionFactory({
  requestFunction: () => getClient("memoryService").fetchAllLocations(),
  storeAction: receiveLocations,
  errorHandler
});

export const fetchLocationsIfNotFetched =
  () => async (dispatch: Dispatch, getState: GetState) => {
    if (locationsNeedFetching(getState())) {
      dispatch(fetchLocations());
    }
  };
